import { useEffect } from 'react';

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

export default function SEO({ title, description, path }) {
    useEffect(() => {
        if (title) document.title = title;
        upsertMeta('name', 'description', description);
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:type', 'website');
        if (path) upsertMeta('property', 'og:url', window.location.origin + path);
    }, [title, description, path]);
    return null;
}
